import Parse from 'parse'

import config from '../config'

import auth from './auth'
import etfs from './etfs'
import strapi from './strapi'
import contact from './contact'
import healthcheck from './healthcheck'

// Parse initialization
Parse.initialize(config.parse.appId)
Parse.serverURL = config.parse.serverURL

export default {
  parse: Parse,
  auth,
  etfs,
  strapi,
  contact,
  healthcheck
}
